import list from 'src/modules/eLabel/list/eLabelListReducers';
import importerReducer from 'src/modules/eLabel/importer/eLabelImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  importer: importerReducer,
});
